import React, { useState } from "react";
import { _t } from "core/language";
import CartIcon from "../../assets/icons/commons/cart.svg";
import { type TIngredient } from 'modules/Ingredients/store/types';
import { useUpdateCart } from "modules/Carts/hooks";
import { UpdateCart } from "modules/Carts/store/types";
import { ActionTypeEnumCart } from "core/config/constant";
import { ActionType } from ".";
import CDialog from "../CDialog";
import { useSelector } from "react-redux";
import { useAuthModal } from "core/context";

interface GroupActionProps {
  ingredient: TIngredient;
}

const Cart: React.FC<GroupActionProps> = ({
  ingredient,
}) => {
  const { openModal, token } = useAuthModal();
  const [stateDialogExistCart, setStateDialogExistCart] = useState(false);
  const [stateDialogAddCart, setStateDialogAddCart] = useState({
    state:false,
    data:{} as UpdateCart
  });
  const [lisCartAdd, setListCardAdd] = useState<any>([]); // cart list under local when adding new will be pushed into array
  const { updateCart } = useUpdateCart()
  const { dataList } = useSelector((state: any) => state.Carts || {});
  
  const handleClick = (type: any, data:any) => {
    if (!token) {
      openModal(() => {
        document.getElementById(`cart-${data?.id}`)?.click()
        // reload?.((newState: boolean) => {
        //   if (!newState) {
        //   }
        // })
      });
      return;
    }
    if([ActionType.ADDCART].includes(type)){
      if(!data?.id) return
      const dataRequest = {
        ids:[data?.id],
        action:ActionTypeEnumCart.ADD
      }
      const hasId = dataList.some((item:any) => item.id === data?.id);
      const hasIdLocal = lisCartAdd.some((item:any) => item === data?.id);
      if(hasId || hasIdLocal) {
        setStateDialogExistCart(true)
      }else {
        setStateDialogAddCart({...stateDialogAddCart,state:true, data:dataRequest})
      }
    }
  }

  const handleAddCart = () => {
    const dataCart = {
        ids:stateDialogAddCart?.data?.ids || '',
        action:stateDialogAddCart?.data?.action || ''
    }
    updateCart(dataCart)
    setStateDialogAddCart({...stateDialogAddCart,state:false, data:{} as UpdateCart})
    setListCardAdd([...lisCartAdd, ...(stateDialogAddCart?.data?.ids ? [stateDialogAddCart?.data?.ids[0]] : [])]);
  }

  return <>
    <img
      id={`cart-${ingredient?.id}`}
      src={CartIcon}
      alt=""
      onClick={() => handleClick(ActionType.ADDCART,ingredient)}
    />
    <CDialog
        open={stateDialogExistCart}
        closeModal={() => { setStateDialogExistCart(false) }}
        classNamechildren={'pb-[20px]'}
        isButton={false}
        submitText={_t('recipe.msg.confirm')}
        closeText={_t('recipe.msg.cancel')}
      >
        <p className="text-sm font-medium mb-[30px]">{_t('recipe.recipe_exist_in_cart')}</p>
      </CDialog>
      <CDialog
        open={stateDialogAddCart.state}
        closeModal={() => { setStateDialogAddCart({...stateDialogAddCart,state:false}) }}
        classNamechildren={'pb-[30px]'}
        handleSubmit={handleAddCart}
        submitText={_t('recipe.msg.confirm')}
        closeText={_t('recipe.msg.cancel')}
      >
        <p className="text-sm font-medium">{_t('recipe.recipe_want_add_to_cart')}</p>
      </CDialog>
  </>
};

export default Cart;
